const translations = {
  en: {
    about: 'About us',
    clients: 'Clients',
    contactAnswer: 'Get in touch with us to find out how we can help!',
    faq: 'Frequently Ask Questions',
    legaNotice : 'Legal Notice',
    otherProjects: 'See more work',
    partners: 'Partners',
    projects: 'Work',
    services: 'Services',
    team: 'Team',
    questionTag: 'We\'d love to hear from you.',
  },
  fr: {
    about: 'À propos',
    clients: 'Clients',
    contactAnswer: 'On vous répond',
    faq: 'Foire Aux Questions',
    legaNotice : 'Mentions légales',
    otherProjects: 'Autres réalisations',
    partners: 'Partenaires',
    projects: 'Réalisations',
    services: 'Services',
    team: 'L\'équipe',
    questionTag: 'Une question ?',
  }
}

export default translations